import { z } from "zod/v4";

export const SortStateSchema = z.object({
  field: z.string(),
  order: z.enum(["ASC", "DESC"]),
});
export type SortState = z.infer<typeof SortStateSchema>;

// Use this type when setting pagination state for antd based table components
export type PaginationState = {
  current: number;
  pageSize: number;
};

export type PagingState = {
  currentPage: number;
  pageSize: number;
};

export type SearchParams<Filters extends Record<string, any>> = {
  sort: SortState;
  filters: Filters;
  paging?: PagingState;
};
